import brand, { colourWithTransparency } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h1, h5, paragraphRegular } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import ResourceCardStyles from '@stories/Components/Cards/ResourceCard/ResourceCard.styles';
import FiltersStyles from '@stories/Components/Listings/Filters/Filters.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
import BreadCrumbsStyles from '../Global/BreadCrumbs/BreadCrumbs.styles';
import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
const Wrapper = styled.div `
  ${BreadCrumbsStyles.Container} {
    ${SectionWrapperStyles.Inner} {
      padding-top: 16px;
      padding-bottom: 0;
    }
  }

  ${BreadCrumbsStyles.List} {
    margin-bottom: 0;
  }
`;
const SearchBanner = styled.div `
  --bannerBgColour: ${brand.primary.pear.pearBg};
  --bannerTagBgColour: ${brand.primary.pear.pear25};
  --bannerTagBorderColour: ${brand.primary.pear.pear100};
  --searchAreaBgColour: ${brand.primary.pear.pear50};
  --searchBtnColour: ${brand.primary.pear.pear100};
  --searchBtnHoverColour: ${brand.primary.pear.pear50};
  --searchBtnActiveColour: ${brand.primary.pear.pear75};
  --searchBtnFgColour: ${brand.global.black};
  --searchBtnBorderColour: ${brand.primary.pear.pear100};
  --searchBtnBorderHoverColour: ${brand.primary.pear.pear50};
  --searchBtnBorderActiveColour: ${brand.primary.pear.pear100};

  --paddingTop: 280px;

  padding-top: var(--paddingTop);
  padding-bottom: ${fluid(40, 108)};
  background-color: var(--bannerBgColour);

  [data-theme='teal'] & {
    --bannerBgColour: ${brand.primary.teal.tealBg};
    --bannerTagBgColour: ${brand.primary.teal.teal25};
    --bannerTagBorderColour: ${brand.primary.teal.teal100};
    --searchAreaBgColour: ${brand.secondary.purple.purple50};
    --searchBtnColour: ${brand.secondary.purple.purple100};
    --searchBtnHoverColour: ${brand.secondary.purple.purple50};
    --searchBtnActiveColour: ${brand.secondary.purple.purple75};
    --searchBtnFgColour: ${brand.global.white};
    --searchBtnBorderColour: ${brand.secondary.purple.purple100};
    --searchBtnBorderHoverColour: ${brand.secondary.purple.purple50};
    --searchBtnBorderActiveColour: ${brand.secondary.purple.purple100};
  }

  [data-theme='purple'] & {
    --bannerBgColour: ${brand.secondary.purple.purpleBg};
    --bannerTagBgColour: ${brand.secondary.purple.purple25};
    --bannerTagBorderColour: ${brand.secondary.purple.purple100};
    --searchAreaBgColour: ${brand.secondary.purple.purple50};
    --searchBtnColour: ${brand.secondary.purple.purple100};
    --searchBtnHoverColour: ${brand.secondary.purple.purple50};
    --searchBtnActiveColour: ${brand.secondary.purple.purple75};
    --searchBtnFgColour: ${brand.global.white};
    --searchBtnBorderColour: ${brand.secondary.purple.purple100};
    --searchBtnBorderHoverColour: ${brand.secondary.purple.purple50};
    --searchBtnBorderActiveColour: ${brand.secondary.purple.purple100};
  }

  [data-theme='pear'] & {
    --bannerBgColour: ${brand.primary.pear.pearBg};
    --bannerTagBgColour: ${brand.primary.pear.pear25};
    --bannerTagBorderColour: ${brand.primary.pear.pear100};
    --searchAreaBgColour: ${brand.primary.pear.pear50};
    --searchBtnColour: ${brand.primary.pear.pear100};
    --searchBtnHoverColour: ${brand.primary.pear.pear50};
    --searchBtnActiveColour: ${brand.primary.pear.pear75};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnBorderColour: ${brand.primary.pear.pear100};
    --searchBtnBorderHoverColour: ${brand.primary.pear.pear50};
    --searchBtnBorderActiveColour: ${brand.primary.pear.pear100};
  }
  
  [data-theme='blue'] & {
    --bannerBgColour: ${brand.primary.blue.blueBg};
    --bannerTagBgColour: ${brand.primary.blue.blue25};
    --bannerTagBorderColour: ${brand.primary.blue.blue100};
    --searchAreaBgColour: ${brand.primary.blue.blue50};
    --searchBtnColour: ${brand.primary.blue.blue100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.primary.blue.blue50};
    --searchBtnActiveColour: ${brand.primary.blue.blue75};
    --searchBtnBorderColour: ${brand.primary.blue.blue100};
    --searchBtnBorderHoverColour: ${brand.primary.blue.blue50};
    --searchBtnBorderActiveColour: ${brand.primary.blue.blue100};
  }
  
  [data-theme='orange'] & {
    --bannerBgColour: ${brand.secondary.orange.orangeBg};
    --bannerTagBgColour: ${brand.secondary.orange.orange25};
    --bannerTagBorderColour: ${brand.secondary.orange.orange100};
    --searchAreaBgColour: ${brand.secondary.orange.orange50};
    --searchBtnColour: ${brand.secondary.orange.orange100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.secondary.orange.orange50};
    --searchBtnActiveColour: ${brand.secondary.orange.orange75};
    --searchBtnBorderColour: ${brand.secondary.orange.orange100};
    --searchBtnBorderHoverColour: ${brand.secondary.orange.orange50};
    --searchBtnBorderActiveColour: ${brand.secondary.orange.orange100};
  }
  
  [data-theme='dark-blue'] & {
    --bannerBgColour: ${brand.accent.darkBlue.darkBlueBg};
    --bannerTagBgColour: ${brand.accent.darkBlue.darkBlue25};
    --bannerTagBorderColour: ${brand.accent.darkBlue.darkBlue100};
    --searchAreaBgColour: ${brand.accent.darkBlue.darkBlue50};
    --searchBtnColour: ${brand.accent.darkBlue.darkBlue100};
    --searchBtnFgColour: ${brand.global.white};
    --searchBtnHoverColour: ${brand.accent.darkBlue.darkBlue50};
    --searchBtnActiveColour: ${brand.accent.darkBlue.darkBlue75};
    --searchBtnBorderColour: ${brand.accent.darkBlue.darkBlue100};
    --searchBtnBorderHoverColour: ${brand.accent.darkBlue.darkBlue50};
    --searchBtnBorderActiveColour: ${brand.accent.darkBlue.darkBlue100};
  }
  
  [data-theme='forrest-green'] & {
    --bannerBgColour: ${brand.accent.forrestGreen.forrestGreenBg};
    --bannerTagBgColour: ${brand.accent.forrestGreen.forrestGreen25};
    --bannerTagBorderColour: ${brand.accent.forrestGreen.forrestGreen100};
    --searchAreaBgColour: ${brand.accent.forrestGreen.forrestGreen50};
    --searchBtnColour: ${brand.accent.forrestGreen.forrestGreen100};
    --searchBtnFgColour: ${brand.global.white};
    --searchBtnHoverColour: ${brand.accent.forrestGreen.forrestGreen50};
    --searchBtnActiveColour: ${brand.accent.forrestGreen.forrestGreen75};
    --searchBtnBorderColour: ${brand.accent.forrestGreen.forrestGreen100};
    --searchBtnBorderHoverColour: ${brand.accent.forrestGreen.forrestGreen50};
    --searchBtnBorderActiveColour: ${brand.accent.forrestGreen.forrestGreen100};
  }
  
  [data-theme='engage-green'] & {
    --bannerBgColour: ${brand.engagePrimary.green.green25};
    --bannerTagBgColour: ${brand.engagePrimary.green.green50};
    --bannerTagBorderColour: ${brand.engagePrimary.green.green100};
    --searchAreaBgColour: ${brand.engagePrimary.green.green50};
    --searchBtnColour: ${brand.engagePrimary.green.green100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engagePrimary.green.green50};
    --searchBtnActiveColour: ${brand.engagePrimary.green.green75};
    --searchBtnBorderColour: ${brand.engagePrimary.green.green100};
    --searchBtnBorderHoverColour: ${brand.engagePrimary.green.green50};
    --searchBtnBorderActiveColour: ${brand.engagePrimary.green.green100};
  }
  
  [data-theme='engage-sea-green'] & {
    --bannerBgColour: ${brand.engagePrimary.seaGreen.seaGreen25};
    --bannerTagBgColour: ${brand.engagePrimary.seaGreen.seaGreen50};
    --bannerTagBorderColour: ${brand.engagePrimary.seaGreen.seaGreen100};
    --searchAreaBgColour: ${brand.engagePrimary.seaGreen.seaGreen50};
    --searchBtnColour: ${brand.engagePrimary.seaGreen.seaGreen100};
    --searchBtnFgColour: ${brand.global.white};
    --searchBtnHoverColour: ${brand.engagePrimary.seaGreen.seaGreen50};
    --searchBtnActiveColour: ${brand.engagePrimary.seaGreen.seaGreen75};
    --searchBtnBorderColour: ${brand.engagePrimary.seaGreen.seaGreen100};
    --searchBtnBorderHoverColour: ${brand.engagePrimary.seaGreen.seaGreen50};
    --searchBtnBorderActiveColour: ${brand.engagePrimary.seaGreen.seaGreen100};
  }
  
  [data-theme='engage-purple'] & {
    --bannerBgColour: ${brand.engageSecondary.purple.purple25};
    --bannerTagBgColour: ${brand.engageSecondary.purple.purple50};
    --bannerTagBorderColour: ${brand.engageSecondary.purple.purple100};
    --searchAreaBgColour: ${brand.engageSecondary.purple.purple50};
    --searchBtnColour: ${brand.engageSecondary.purple.purple100};
    --searchBtnFgColour: ${brand.global.white};
    --searchBtnHoverColour: ${brand.engageSecondary.purple.purple50};
    --searchBtnActiveColour: ${brand.engageSecondary.purple.purple75};
    --searchBtnBorderColour: ${brand.engageSecondary.purple.purple100};
    --searchBtnBorderHoverColour: ${brand.engageSecondary.purple.purple50};
    --searchBtnBorderActiveColour: ${brand.engageSecondary.purple.purple100};
  }
  
  [data-theme='engage-lilac'] & {
    --bannerBgColour: ${brand.engageSecondary.lilac.lilac25};
    --bannerTagBgColour: ${brand.engageSecondary.lilac.lilac50};
    --bannerTagBorderColour: ${brand.engageSecondary.lilac.lilac100};
    --searchAreaBgColour: ${brand.engageSecondary.lilac.lilac50};
    --searchBtnColour: ${brand.engageSecondary.lilac.lilac100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engageSecondary.lilac.lilac50};
    --searchBtnActiveColour: ${brand.engageSecondary.lilac.lilac75};
    --searchBtnBorderColour: ${brand.engageSecondary.lilac.lilac100};
    --searchBtnBorderHoverColour: ${brand.engageSecondary.lilac.lilac50};
    --searchBtnBorderActiveColour: ${brand.engageSecondary.lilac.lilac100};
  }
  
  [data-theme='engage-tangerine'] & {
    --bannerBgColour: ${brand.engageSecondary.tangerine.tangerine25};
    --bannerTagBgColour: ${brand.engageSecondary.tangerine.tangerine50};
    --bannerTagBorderColour: ${brand.engageSecondary.tangerine.tangerine100};
    --searchAreaBgColour: ${brand.engageSecondary.tangerine.tangerine50};
    --searchBtnColour: ${brand.engageSecondary.tangerine.tangerine100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engageSecondary.tangerine.tangerine50};
    --searchBtnActiveColour: ${brand.engageSecondary.tangerine.tangerine75};
    --searchBtnBorderColour: ${brand.engageSecondary.tangerine.tangerine100};
    --searchBtnBorderHoverColour: ${brand.engageSecondary.tangerine.tangerine50};
    --searchBtnBorderActiveColour: ${brand.engageSecondary.tangerine.tangerine100};
  }
  
  [data-theme='engage-lavender'] & {
    --bannerBgColour: ${brand.engageSecondary.lavender.lavender25};
    --bannerTagBgColour: ${brand.engageSecondary.lavender.lavender50};
    --bannerTagBorderColour: ${brand.engageSecondary.lavender.lavender100};
    --searchAreaBgColour: ${brand.engageSecondary.lavender.lavender50};
    --searchBtnColour: ${brand.engageSecondary.lavender.lavender100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engageSecondary.lavender.lavender50};
    --searchBtnActiveColour: ${brand.engageSecondary.lavender.lavender75};
    --searchBtnBorderColour: ${brand.engageSecondary.lavender.lavender100};
    --searchBtnBorderHoverColour: ${brand.engageSecondary.lavender.lavender50};
    --searchBtnBorderActiveColour: ${brand.engageSecondary.lavender.lavender100};
  }
  
  [data-theme='engage-pink'] & {
    --bannerBgColour: ${brand.engageSecondary.pink.pink25};
    --bannerTagBgColour: ${brand.engageSecondary.pink.pink50};
    --bannerTagBorderColour: ${brand.engageSecondary.pink.pink100};
    --searchAreaBgColour: ${brand.engageSecondary.pink.pink50};
    --searchBtnColour: ${brand.engageSecondary.pink.pink100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engageSecondary.pink.pink50};
    --searchBtnActiveColour: ${brand.engageSecondary.pink.pink75};
    --searchBtnBorderColour: ${brand.engageSecondary.pink.pink100};
    --searchBtnBorderHoverColour: ${brand.engageSecondary.pink.pink50};
    --searchBtnBorderActiveColour: ${brand.engageSecondary.pink.pink100};
  }
  
  [data-theme='engage-sky'] & {
    --bannerBgColour: ${brand.engagePrimary.sky.sky25};
    --bannerTagBgColour: ${brand.engagePrimary.sky.sky50};
    --bannerTagBorderColour: ${brand.engagePrimary.sky.sky100};
    --searchAreaBgColour: ${brand.engagePrimary.sky.sky50};
    --searchBtnColour: ${brand.engagePrimary.sky.sky100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engagePrimary.sky.sky50};
    --searchBtnActiveColour: ${brand.engagePrimary.sky.sky75};
    --searchBtnBorderColour: ${brand.engagePrimary.sky.sky100};
    --searchBtnBorderHoverColour: ${brand.engagePrimary.sky.sky50};
    --searchBtnBorderActiveColour: ${brand.engagePrimary.sky.sky100};
  }
  
  [data-theme='engage-lime'] & {
    --bannerBgColour: ${brand.engagePrimary.lime.lime25};
    --bannerTagBgColour: ${brand.engagePrimary.lime.lime50};
    --bannerTagBorderColour: ${brand.engagePrimary.lime.lime100};
    --searchAreaBgColour: ${brand.engagePrimary.lime.lime50};
    --searchBtnColour: ${brand.engagePrimary.lime.lime100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engagePrimary.lime.lime50};
    --searchBtnActiveColour: ${brand.engagePrimary.lime.lime75};
    --searchBtnBorderColour: ${brand.engagePrimary.lime.lime100};
    --searchBtnBorderHoverColour: ${brand.engagePrimary.lime.lime50};
    --searchBtnBorderActiveColour: ${brand.engagePrimary.lime.lime100};
  }
  
  [data-theme='engage-teal'] & {
    --bannerBgColour: ${brand.engagePrimary.teal.teal25};
    --bannerTagBgColour: ${brand.engagePrimary.teal.teal50};
    --bannerTagBorderColour: ${brand.engagePrimary.teal.teal100};
    --searchAreaBgColour: ${brand.engagePrimary.teal.teal50};
    --searchBtnColour: ${brand.engagePrimary.teal.teal100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engagePrimary.teal.teal50};
    --searchBtnActiveColour: ${brand.engagePrimary.teal.teal75};
    --searchBtnBorderColour: ${brand.engagePrimary.teal.teal100};
    --searchBtnBorderHoverColour: ${brand.engagePrimary.teal.teal50};
    --searchBtnBorderActiveColour: ${brand.engagePrimary.teal.teal100};
  }
  
  [data-theme='engage-yellow'] & {
    --bannerBgColour: ${brand.engageSecondary.yellow.yellow25};
    --bannerTagBgColour: ${brand.engageSecondary.yellow.yellow50};
    --bannerTagBorderColour: ${brand.engageSecondary.yellow.yellow100};
    --searchAreaBgColour: ${brand.engageSecondary.yellow.yellow50};
    --searchBtnColour: ${brand.engageSecondary.yellow.yellow100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engageSecondary.yellow.yellow50};
    --searchBtnActiveColour: ${brand.engageSecondary.yellow.yellow75};
    --searchBtnBorderColour: ${brand.engageSecondary.yellow.yellow100};
    --searchBtnBorderHoverColour: ${brand.engageSecondary.yellow.yellow50};
    --searchBtnBorderActiveColour: ${brand.engageSecondary.yellow.yellow100};
  }

  [data-theme='bronze'] & {
    --bannerBgColour: ${brand.awards.bronze.bronzeBg};
    --bannerTagBgColour: ${brand.awards.bronze.bronze25};
    --bannerTagBorderColour: ${brand.awards.bronze.bronze100};
    --searchAreaBgColour: ${brand.awards.bronze.bronze50};
    --searchBtnColour: ${brand.awards.bronze.bronze100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.awards.bronze.bronze50};
    --searchBtnActiveColour: ${brand.awards.bronze.bronze75};
    --searchBtnBorderColour: ${brand.awards.bronze.bronze100};
    --searchBtnBorderHoverColour: ${brand.awards.bronze.bronze50};
    --searchBtnBorderActiveColour: ${brand.awards.bronze.bronze100};
  }

  [data-theme='silver'] & {
    --bannerBgColour: ${brand.awards.silver.silverBg};
    --bannerTagBgColour: ${brand.awards.silver.silver25};
    --bannerTagBorderColour: ${brand.awards.silver.silver100};
    --searchAreaBgColour: ${brand.awards.silver.silver50};
    --searchBtnColour: ${brand.awards.silver.silver100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.awards.silver.silver50};
    --searchBtnActiveColour: ${brand.awards.silver.silver75};
    --searchBtnBorderColour: ${brand.awards.silver.silver100};
    --searchBtnBorderHoverColour: ${brand.awards.silver.silver50};
    --searchBtnBorderActiveColour: ${brand.awards.silver.silver100};
  }

  [data-theme='gold'] & {
    --bannerBgColour: ${brand.awards.gold.goldBg};
    --bannerTagBgColour: ${brand.awards.gold.gold25};
    --bannerTagBorderColour: ${brand.awards.gold.gold100};
    --searchAreaBgColour: ${brand.awards.gold.gold50};
    --searchBtnColour: ${brand.awards.gold.gold100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.awards.gold.gold50};
    --searchBtnActiveColour: ${brand.awards.gold.gold75};
    --searchBtnBorderColour: ${brand.awards.gold.gold100};
    --searchBtnBorderHoverColour: ${brand.awards.gold.gold50};
    --searchBtnBorderActiveColour: ${brand.awards.gold.gold100};
  }

  [data-theme='engage-dusk'] & {
    --bannerBgColour: ${brand.engageNeutral.dusk};
    --bannerTagBgColour: ${brand.engageSecondary.lilac.lilac50};
    --bannerTagBorderColour: ${brand.engageSecondary.lilac.lilac100};
    --searchAreaBgColour: ${brand.engageSecondary.lilac.lilac50};
    --searchBtnColour: ${brand.engageSecondary.lilac.lilac100};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engageSecondary.lilac.lilac50};
    --searchBtnActiveColour: ${brand.engageSecondary.lilac.lilac75};
    --searchBtnBorderColour: ${brand.engageSecondary.lilac.lilac100};
    --searchBtnBorderHoverColour: ${brand.engageSecondary.lilac.lilac50};
    --searchBtnBorderActiveColour: ${brand.engageSecondary.lilac.lilac100};    
  }

  [data-theme='engage-cream'] & {
    --bannerBgColour: ${brand.engageNeutral.cream};
    --bannerTagBgColour: ${brand.engageSecondary.tangerine.tangerine25};
    --bannerTagBorderColour: ${brand.engageSecondary.tangerine.tangerine75};
    --searchAreaBgColour: ${brand.engageSecondary.tangerine.tangerine25};
    --searchBtnColour: ${brand.engageSecondary.tangerine.tangerine75};
    --searchBtnFgColour: ${brand.global.black};
    --searchBtnHoverColour: ${brand.engageSecondary.tangerine.tangerine25};
    --searchBtnActiveColour: ${brand.engageSecondary.tangerine.tangerine50};
    --searchBtnBorderColour: ${brand.engageSecondary.tangerine.tangerine75};
    --searchBtnBorderHoverColour: ${brand.engageSecondary.tangerine.tangerine25};
    --searchBtnBorderActiveColour: ${brand.engageSecondary.tangerine.tangerine75};  
  }
`;
const SearchBannerContainer = styled(SectionWrapper) `
  overflow: hidden;
`;
const SearchBannerGrid = styled.div `
  ${baseGrid};

  grid-template-rows: auto auto;
  column-gap: 24px;
  row-gap: ${fluid(0, 18)};

  
`;
const BannerTag = styled.div `
  grid-column: 8 / span 5;
  grid-row: 1;

  @media ${until(Device.TabletLarge)} {
    grid-column: span 12;
    order: 1;
    margin-bottom: 8px;
  }
`;
const BannerTagInner = styled.div `
  ${fonts.gotham.bold};
  display: inline-flex;
  font-size: ${fluid(14, 16)};
  line-height: 18px;
  padding: ${fluid(8, 12)} ${fluid(16, 24)};
  border-radius: 100000000000px;
  background-color: var(--bannerTagBgColour);
  border: 2px solid var(--bannerTagBorderColour);
`;
const SearchArea = styled.div `
  grid-column: span 6;
  grid-row: 2;
  padding-bottom: 33px;
  
  @media ${until(Device.TabletLarge)} {
    grid-column: span 12;
    order: 3;
    grid-row: 3;
    padding-top: 32px;
    padding-bottom: 0;
  }
`;
const SearchInner = styled.div `
  padding: ${fluid(16, 40)};
  padding-bottom: ${fluid(16, 60)};
  background-color: var(--searchAreaBgColour);
  border-radius: ${fluid(16, 40)};
  text-align: center;
  position: relative;
`;
const SearchTitle = styled.span `
  ${h5};
  ${fonts.gotham.bold};
  margin-bottom: ${fluid(16, 32)};
`;
const Search = styled.form `
  width: 100%;
  position: relative;
  background-color: ${brand.global.white};
  border-radius: 10000000000px;
  overflow: hidden;
  padding: ${fluid(4, 8)};
  display: flex;
  gap: 16px;

  > input {
    ${fonts.gotham.regular};

    width: 100%;
    height: ${fluid(43, 68)};
    border: 0;
    font-size: ${fluid(16, 18)};
    line-height: ${fluid(24, 24)};
    margin: 0;
    padding: 0 0 0 ${fluid(21, 34)};
    color: ${brand.global.black};
    border-radius: 10000000000px;

    &:focus {
      outline: 2px solid currentColor;
    }

    &::placeholder {
      color: ${colourWithTransparency(brand.global.black, 0.8)};
    }
  }

  > div {
    flex: 0 0 auto;

    button {
      ${ButtonReset};
      ${transition('background-color, border-color')};
      
      display: flex;
      height: 100%;
      align-items: center;
      background-color: var(--searchBtnColour);
      color: var(--searchBtnFgColour);
      padding: 0 ${fluid(16, 40)};
      gap: ${fluid(6, 8)};
      border-radius: 10000000000px;
      border: 2px solid var(--searchBtnBorderColour);

      &:hover {
        background-color: var(--searchBtnHoverColour);
        border-color: var(--searchBtnBorderHoverColour);
      }

      &:active {
        background-color: var(--searchBtnActiveColour);
        border-color: var(--searchBtnBorderActiveColour);
      }

      @media ${until(Device.TabletLarge)} {
        gap: 0;
      }

      span {
        ${fonts.gotham.bold};
        font-size: ${fluid(16, 18)};
        line-height: ${fluid(20, 23)};

        @media ${until(Device.TabletLarge)} {
          display: none;
        }
      }

      > svg {
        display: block;
        height: ${fluid(20, 24)};
        width: ${fluid(20, 24)};
      }

      &.focus-ring {
        outline: auto;
        outline-offset: 5px;
        outline-width: 2px;
        outline-color: var(--searchBtnBorderColour);
      }
    }
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: span 24;
  }
`;
const PopularSearchArea = styled.div ``;
const PopularSearchTitle = styled.span `
  ${paragraphRegular};
  ${fonts.gotham.bold};
  font-size: 18px;
  line-height: 28px;
  margin-top: ${fluid(20, 32)};
  margin-bottom: ${fluid(8, 16)};

`;
const PopularSearchOptions = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${fluid(8, 8)};

  ${ButtonStyles.Container} {
    --buttonHeight: ${fluid(38, 42)};
    padding: 4px ${fluid(12, 16)} 4px ${fluid(12, 16)};
    gap: 8px;
  }

  ${ButtonStyles.Text} {
    ${fonts.gotham.regular};
    font-size: ${fluid(14, 16)};
    line-height: ${fluid(22, 26)};
  }

  ${ButtonStyles.IconWrapper} {
    width: ${fluid(16, 16)};
    height: ${fluid(16, 16)};
   
  }
`;
const SearchImgArea = styled.div `
  ${imageWrapperPreserveRatio(130, 284)}

  max-width: ${fluid(100, 130, Device.TabletLarge)};
  position: absolute;
  bottom: -33px;
  right: calc(${fluid(80, 100)} * -1);

  img {
    ${imageCoverContainer()}
    object-fit: contain;
  }

  @media ${until(Device.TabletLarge)} {
   display: none;
  }
`;
const BannerContent = styled.div `
  grid-column: 8 / span 5;
  grid-row: 2;

  @media ${until(Device.TabletLarge)} {
    grid-column: span 12;
    order: 2;
  }
`;
const Heading = styled.h1 `
  ${h1};
  line-height: ${fluid(46, 70)};
  color: ${brand.global.black};
  margin-bottom: ${fluid(8, 24)};

`;
const Intro = styled.div `
  ${paragraphRegular};
  ${contentStyles};
  margin-bottom: ${fluid(24, 32)};
`;
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${SectionWrapperStyles.Inner} {
    display: flex;
    flex-direction: column;
    padding-bottom: ${fluid(32, 121)};

    > ${ButtonStyles.Container} {
      margin: ${fluid(40, 76)} auto 0;
    }
  }

  ${FiltersStyles.Container} {
    margin: ${fluid(16, 40)} 0 32px;

    @media ${from(Device.TabletLarge)} {
      margin: ${fluid(32, 36)} 0 ${fluid(16, 32)};
      position: relative;
      z-index: 2;
    }
  }
`;
const TopContainer = styled.div `
  background-color: ${brand.primary.blue.blueBg};
  padding: ${fluid(10, 22)} var(--sitePadding) 24px;
  width: calc(100% + (var(--sitePadding) * 2));
  margin: 0 calc(var(--sitePadding) * -1);
  border-radius: 0px 0px 20px 20px;
`;
const ResultsGrid = styled.div `
  ${baseGrid};

  column-gap: 24px;
  row-gap: ${fluid(16, 56)};
  position: relative;
  z-index: 0;

  ${ResourceCardStyles.Container} {
    grid-column: span 12;

    padding-bottom: 16px;
    border-bottom: 1px solid ${colourWithTransparency(brand.global.black, 0.2)};

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    @media ${from(Device.Tablet)} {
      grid-column: span 6;
      padding-bottom: 0;
      border-bottom: none;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: span 4;
    }
  }
`;
const NoResultsMsg = styled.p `
  ${paragraphRegular};
`;
const ExtraLink = styled.div `
  margin-top: ${fluid(8, 16)};
`;
const ResourceCardListingStyles = {
    BannerContent,
    BannerTag,
    BannerTagInner,
    Container,
    ExtraLink,
    Heading,
    Intro,
    NoResultsMsg,
    PopularSearchArea,
    PopularSearchOptions,
    PopularSearchTitle,
    ResultsGrid,
    Search,
    SearchArea,
    SearchBanner,
    SearchBannerContainer,
    SearchBannerGrid,
    SearchImgArea,
    SearchInner,
    SearchTitle,
    TopContainer,
    Wrapper,
};
export default ResourceCardListingStyles;
